export const projectData = {
  name: "BLISS",
  developer: "AURUM ALUMNI",
  tagline: "Transforming Addresses Into Landmarks",
  subtitle: "Inspiring Every Space",
  description: "Experience luxury living across 7+ acres with only 528 exclusive units. Where modern architecture meets natural serenity.",
  
  contact: {
    phones: ["+91 8586946000"],
    address: "Plot No 21,21A 3rd floor sector 142 Noida 202301",
    projectAddress: "Plot No P-3 & P-4/ TS-2A, Sector-22D, YEIDA, District Gautam Budh Nagar, Uttar Pradesh"
  },
  
  highlights: [
    { title: "7+ Acres", description: "Only 528 Premium Units", icon: "Home" },
    { title: "9 ft Wide Balconies", description: "Semi Wrap-Around Design", icon: "Maximize2" },
    { title: "2 Flats Per Floor", description: "Enhanced Privacy", icon: "Shield" },
    { title: "Temperature Controlled Pool", description: "All Weather Luxury", icon: "Waves" },
    { title: "Mivan Technology", description: "Superior Construction", icon: "Award" },
    { title: "Fully Paid Land", description: "Zero Encumbrance", icon: "CheckCircle" }
  ],
  
  amenities: {
    sports: [
      "Badminton Court",
      "Half Basketball Court",
      "Jogging Track",
      "Pickleball Court",
      "Skating Rink",
      "Tennis Court",
      "Multipurpose Ground",
      "Temperature Controlled Swimming Pool"
    ],
    garden: [
      "Lazy River",
      "Temple",
      "Kids Play Area",
      "Pet Park",
      "Yoga Park",
      "Amphitheatre",
      "Pergola",
      "Forest Trail",
      "Butterfly Garden",
      "Meditation Space",
      "Water Lagoon",
      "Sensory Walk"
    ],
    club: [
      "Sauna & Steam Room",
      "Table Tennis",
      "Cards Room",
      "Mini-Multiplex",
      "Billiards Table",
      "Cafeteria",
      "Gym",
      "Club Privé Pool"
    ]
  },
  
  location: [
    { name: "Jewar Airport", distance: "10 mins", description: "Two runways, operational soon" },
    { name: "Film City", distance: "Nearby", description: "1,000-acre entertainment hub" },
    { name: "Buddh Circuit", distance: "Close", description: "World-class motorsport" },
    { name: "Olympic Park", distance: "Nearby", description: "1,100 acres sports facilities" },
    { name: "Noida", distance: "10 mins", description: "Vibrant urban hub" }
  ],
  
  floorPlans: [
    {
      type: "3 BHK + SQ",
      carpetArea: "1200",
      builtUpArea: "1611",
      features: ["Spacious Layout", "Premium Finishes", "9 ft Balcony", "Servant Quarter"]
    },
    {
      type: "3 BHK + SQ MAX",
      carpetArea: "1548.40",
      builtUpArea: "2200",
      features: ["Maximized Space", "Luxury Fittings", "Wrap-Around Balcony", "Servant Quarter"]
    },
    {
      type: "4 BHK + SQ",
      carpetArea: "1943.76",
      builtUpArea: "2659",
      features: ["Grand Living", "Designer Interiors", "Premium Wood Flooring", "Servant Quarter"]
    },
    {
      type: "4 BHK + SQ MAX",
      carpetArea: "2364.85",
      builtUpArea: "3180",
      features: ["Ultra Luxury", "Imported Marble", "Glass Shower Cubicle", "Servant Quarter"]
    }
  ],
  
  specifications: [
    "Imported marble flooring in living areas",
    "Laminated wooden flooring in bedrooms",
    "Premium ceramic tiles in bathrooms",
    "Modular kitchen with chimney & RO system",
    "Designer POP false ceiling",
    "8 ft high veneered doors",
    "UPVC windows with glass",
    "Branded sanitary ware",
    "High-speed elevators (Kone/Otis)",
    "Fire detection & alarm system",
    "Video door phone",
    "Access controlled entry"
  ],
  
  rera: "UPRERAPRJ376378/11/2024"
};

export const testimonials = [
  {
    name: "Rajesh Kumar",
    role: "Business Owner",
    text: "The attention to detail and premium amenities at Bliss are exceptional. It's truly a landmark address.",
    rating: 5
  },
  {
    name: "Priya Sharma",
    role: "IT Professional",
    text: "Perfect location with Jewar Airport just 10 minutes away. The temperature-controlled pool is a game changer!",
    rating: 5
  },
  {
    name: "Amit Verma",
    role: "Entrepreneur",
    text: "Only 2 flats per floor ensures privacy. The Mivan technology construction quality is outstanding.",
    rating: 5
  }
];
